<template>
  <header>
    <router-link :to="{ name: 'dashboard' }">
      <logo></logo>
    </router-link>
    <nav>
      <div class="dropdown" v-on-clickaway="closeDropDown">
        <button class="white" @click="toggleDropDown">
          <user-icon
            width="16"
            height="16"
            weight="solid"
            fillColor="#7e45ff"
          ></user-icon>
          <span>{{ user }}</span>
          <arrow-icon
            width="14"
            height="14"
            :direction="'down'"
            :cssClass="'chevron'"
          ></arrow-icon>
        </button>
        <div class="menu" v-show="dropdown">
          <router-link
            tag="button"
            :to="{ name: 'profile' }"
            class="white user-profile"
            @click.native="dropdown = false"
          >
            <div>
              <user-icon width="16" height="16" weight="light"></user-icon>
              <span>{{ $t("dashboard-dropdown-account") }}</span>
            </div>
            <arrow-icon
              width="14"
              height="14"
              :direction="'right'"
              :cssClass="'chevron'"
            ></arrow-icon>
          </router-link>
          <button class="white" @click="logOut">
            <sign-out-icon width="16" height="16"></sign-out-icon>
            {{ $t("dashboard-dropdown-logout") }}
          </button>
          <div class="lang-selector">
            <button
              v-for="lang in languages"
              :key="lang.title"
              @click="changeLocale(lang.language)"
              :class="['white', { active: lang.language === locale }]"
            >
              {{ lang.title }}
            </button>
          </div>
        </div>
      </div>
      <button class="primary" @click="showUploadModal">
        <folder-open width="16" height="15"></folder-open>
        {{ $t("dashboard-header-upload") }}
      </button>
    </nav>
  </header>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import { changeLocale } from "@/mixins/localeMixin";
import Logo from "@/components/Logo";
import FolderOpen from "@/components/icons/FolderOpenIcon";
import UserIcon from "@/components/icons/UserIcon";
import ArrowIcon from "@/components/icons/ArrowIcon";
import SignOutIcon from "@/components/icons/SignOutIcon";

export default {
  name: "Header",
  mixins: [clickaway, changeLocale],
  components: {
    Logo,
    FolderOpen,
    UserIcon,
    ArrowIcon,
    SignOutIcon
  },
  data() {
    return {
      dropdown: false
    };
  },
  computed: {
    ...mapState("common", ["languages"]),
    ...mapState("auth", ["user"])
  },
  methods: {
    ...mapActions("common", ["showModal", "showUploadModal"]),
    logOut() {
      this.$store
        .dispatch("auth/logout")
        .then(() => this.$router.push({ name: "login" }))
        .catch(err => {
          this.showModal({
            title: err.errorCode
          });
        });
    },
    toggleDropDown() {
      this.dropdown = !this.dropdown;
    },
    closeDropDown() {
      this.dropdown = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/styles/variables";

header {
  padding: 5px 20px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  nav {
    display: flex;
    .dropdown {
      display: inline-block;
      position: relative;
      > button {
        padding: 0 10px;
        min-width: 200px;
      }
      button {
        justify-content: start;
        svg {
          margin: 5px;
          vertical-align: middle;
        }
      }
      .menu {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
        position: absolute;
        z-index: 2;
        background: white;
        border: 1px solid $middle-gray;
        color: $deadblue;
        border-radius: $radius;
        top: calc(100% + 12px);
        .user-profile {
          display: flex;
          justify-content: space-between;
          align-items: center;
          > div {
            display: flex;
            align-items: center;
            > span {
              display: inline-block;
            }
          }
        }
        &:after,
        &:before {
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          border: solid transparent;
          content: "";
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
        }
        &:after {
          border-color: transparent;
          border-bottom-color: white;
          border-width: 7px;
          margin-left: -8px;
        }
        &:before {
          border-color: transparent;
          border-bottom-color: $middle-gray;
          border-width: 9px;
          margin-left: -8px;
        }
        button {
          border-radius: 0;
          border: none;
          border-bottom: 1px solid $middle-gray;
          text-align: left;
          padding: 5px 10px;
          line-height: normal;
          font-size: 14px;
          font-family: Gotham-book;
          min-height: 42px;
          height: auto;
          svg {
            margin-right: 10px;
          }
        }
        .lang-selector {
          > button {
            padding: 0 15px;
          }
        }
        .lang-selector {
          display: flex;
          button {
            position: relative;
            flex: 1;
            border-bottom: none;
            justify-content: center;
            &.active {
              color: $primary;
            }
            &:last-child {
              text-align: right;
            }
            &:focus,
            &:active {
              z-index: 1;
            }
          }
        }
      }
    }
    > button {
      margin-left: 10px;
    }
  }
}
</style>
